

































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Route, NavigationGuardNext } from 'vue-router';
import { ValidationObserver } from 'vee-validate';
import { Getter } from 'vuex-class';
import EditorActionMixin from '@/mixins/editor-action';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import { adminRole, AdminRoleList, AdminRoles } from '@/configs/role';
import { postCreateAdmin, getAdminDetail, putAdminDetail } from '@/configs/api-path';
import { StatusOption, statusOptions } from '@/configs/status';
import { AdminDetail, AdminListItem } from '@/models/admin';
import { ProjectMenu } from '@/models/project';
import { encryptSha1 } from '@/utils/crypto';
import sleep from '@/utils/sleep';

const SECRET_SALT = process.env.VUE_APP_SECRET_SALT;

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component
export default class PageAdminEdit extends mixins(
  EditorActionMixin, ApiStatusMixin, ApiErrorMixin,
) {
  $refs!: {
    formObs: InstanceType<typeof ValidationObserver>;
  }

  adminRoles: AdminRoleList[] = adminRole;

  statusOptions: StatusOption[] = statusOptions;

  adminForm: AdminDetail = {
    id: null,
    name: '',
    mobile: '',
    email: null,
    password: null,
    description: null,
    projectId: 0,
    status: false,
    role: AdminRoles.admin,
  };

  get adminId(): number | null {
    return this.adminForm.id;
  }

  get headingTitle() {
    return this.isCreateAction ? '新增' : '編輯';
  }

  get basicTitle() {
    return this.isCreateAction ? '新增使用者帳號' : '修改使用者帳號';
  }

  get submitText() {
    return this.isCreateAction ? '新增' : '儲存';
  }

  get adminRoleOptions() {
    return this.isCreateAction
      ? this.adminRoles
        .filter((role) => role.code > this.getUserRoleId)
        .map((role) => ({
          code: role.code,
          label: role.text,
        }))
      : this.adminRoles
        .filter((role) => [2, 3, 4].includes(role.code))
        .map((role) => ({
          code: role.code,
          label: role.text,
        }));
  }

  get projectOptions(): {
    code: string | number | null;
    label: string;
  }[] {
    const projects = this.isCreateAction
      ? this.menuProjects.map((project) => ({
        code: project.id,
        label: project.name,
      }))
      : this.allMenuProjects.map((project) => ({
        code: project.id,
        label: project.name,
      }));
    return [
      {
        code: 0,
        label: '請選擇',
      },
      ...projects,
    ];
  }

  get isStaff() {
    return this.adminForm.role === AdminRoles.staff;
  }

  get isFormChanged() {
    return this.$refs.formObs.flags.changed;
  }

  // eslint-disable-next-line class-methods-use-this
  get breadcrumb() {
    return [
      {
        text: '帳號管理',
        to: null,
      },
      // {
      //   text: `${this.headingTitle}帳號`,
      //   to: null,
      // },
    ];
  }

  @Getter('app/getMenuProjectsLastest') menuProjects!: ProjectMenu[];

  @Getter('app/getMenuProjectsAll') allMenuProjects!: ProjectMenu[];

  @Getter('user/getRoleId') getUserRoleId!: number;

  @Watch('adminForm.role')
  onAdminFormRoleChanged(newValue: AdminRoles) {
    if (newValue !== AdminRoles.staff) {
      this.adminForm.projectId = 0;
    }
  }

  setDefaultAdminRoleId() {
    if (!this.isCreateAction) {
      return;
    }
    const newRoleId = this.adminRoles.find((role) => role.code > this.getUserRoleId);

    if (newRoleId) {
      this.adminForm.role = newRoleId.code;
    }
  }

  // Proxy editor action
  adminSubmit() {
    if (this.isCreateAction) {
      this.createAdminHandler();
    } else if (this.isEditAction) {
      this.editAdminHandler();
    }
  }

  cancelEdit() {
    this.$router.push({
      name: 'admin-list',
    });
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    if (this.isFormChanged) {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm(`確定取消${this.headingTitle}？\n離開後變更的資料將不會被儲存。`);

      if (confirm === false) {
        return;
      }
      next();
      return;
    }
    next();
  }

  async fetchAdmin() {
    this.setApiLoading();
    try {
      const { adminId } = this.$route.params;
      const { data: adminResponse } = await this.$axios.get<{
        code: number;
        admin: AdminDetail;
      }>(getAdminDetail(adminId));

      if (adminResponse.code === 0) {
        this.adminForm.id = adminResponse.admin.id;
        this.adminForm.name = adminResponse.admin.name;
        this.adminForm.mobile = adminResponse.admin.mobile;
        this.adminForm.email = adminResponse.admin.email;
        this.adminForm.description = adminResponse.admin.description;
        this.adminForm.projectId = adminResponse.admin.projectId;
        this.adminForm.status = adminResponse.admin.status;
        this.adminForm.role = adminResponse.admin.role;
      } else {
        this.apiErrorCodeAlert(adminResponse.code, '編輯帳號');
        this.$router.replace({
          name: 'admin-list',
        });
      }
    } catch (error) {
      console.error(error);
    }

    this.$refs.formObs.reset();
    this.setApiPending();
  }

  async createAdminHandler() {
    this.setApiLoading();
    try {
      const password = encryptSha1(`${SECRET_SALT}${this.adminForm.password}${SECRET_SALT}`);

      const createData = {
        ...this.adminForm,
        password,
      };

      const { data: createResponse } = await this.$axios.post<{
        code: number;
        admin: AdminListItem;
      }>(postCreateAdmin, createData);

      if (createResponse.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '帳號已新增！', '新增帳號', { duration: 3000, permanent: false });
        this.$router.push({
          name: 'admin-list',
        });
      } else {
        this.apiErrorCodeAlert(createResponse.code);
      }
    } catch (error) {
      console.error(error);
      // this.apiErrorCodeAlert(code);
    }
    this.setApiPending();
  }

  async editAdminHandler() {
    this.setApiLoading();
    try {
      if (!this.adminId) {
        return;
      }
      let password;
      if (this.adminForm.password !== null) {
        password = encryptSha1(`${SECRET_SALT}${this.adminForm.password}${SECRET_SALT}`);
      }

      const updateData = {
        name: this.adminForm.name,
        email: this.adminForm.email,
        password,
        description: this.adminForm.description,
      };

      const { data: updateResponse } = await this.$axios.put<{
        code: number;
        user: {
          id: number;
        };
      }>(putAdminDetail(this.adminId), updateData);

      if (updateResponse.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '資料已更新成功！', '編輯帳號', { duration: 3000, permanent: false });
        this.$router.push({
          name: 'admin-list',
        });
      } else {
        this.apiErrorCodeAlert(updateResponse.code);
      }
    } catch (error) {
      console.error(error);
      // this.apiErrorCodeAlert(code);
    }
    this.setApiPending();
  }

  beforeMount() {
    this.setDefaultAdminRoleId();
    // console.log(this.editorAction, this.isCreateAction, this.isEditAction);
    if (this.editorAction && this.$route.params.adminId) {
      this.fetchAdmin();
    }
  }
}
